/*eslint eqeqeq: "off"*/
import {
  Form1099bServiceClient,
  Form1099bRequest,
  DownLoadBRequest,
} from '../proto/taxfilingpb/form1099b_grpc_web_pb';
import { notifyError, notifySuccess } from '../components/Messages/Notification';
import { auth } from '../lib/auth/Auth';
import download from './DownloadService';

const service = new Form1099bServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

export async function listForm1099b(param) {
  return new Promise((resolve, reject) => {
    const req = new Form1099bRequest();
    req.setYear(param.year);
    req.setCorrespondent(param.correspondent);
    req.setBranch(param.branch);
    req.setAccountNo(param.accountNo);
    req.setUsrId(param.usrId);

    service.listForm1099b(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function form1099bDetails(param) {
  return new Promise((resolve, reject) => {
    const req = new Form1099bRequest();
    req.setYear(param.year);
    req.setCorrespondent(param.correspondent);
    req.setBranch(param.branch);
    req.setAccountNo(param.accountNo);
    req.setUsrId(param.usrId);

    service.form1099bDetails(req, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function downloadB(param, filetype, batchNo, downloadType) {
  return new Promise((resolve, reject) => {
    let request = new DownLoadBRequest();
    request.setFileType(filetype);
    request.setBatchNo(batchNo);
    request.setDownloadType(downloadType);
    let req = new Form1099bRequest();
    req.setYear(param.year);
    req.setCorrespondent(param.correspondent);
    req.setBranch(param.branch);
    req.setAccountNo(param.accountNo);
    req.setUsrId(param.usrId);
    request.setForm1099BRequest(req);
    service.download(request, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        if (response) {
          download(response);
          resolve(response);
          if (response?.array[2]) {
            notifySuccess('Download ' + response.array[2] + ' completed');
          } else {
            notifySuccess('Download completed');
          }
        }
      }
    });
  });
}

export async function generateB(param, filetype, batchNo, downloadType) {
  return new Promise((resolve, reject) => {
    let request = new DownLoadBRequest();
    request.setFileType(filetype);
    request.setBatchNo(batchNo);
    request.setDownloadType(downloadType);
    let req = new Form1099bRequest();
    req.setYear(param.year);
    req.setCorrespondent(param.correspondent);
    req.setBranch(param.branch);
    req.setAccountNo(param.accountNo);
    req.setUsrId(param.usrId);
    request.setForm1099BRequest(req);

    service.generate(request, {}, (error, response) => {
      if (error) {
        notifyError(error.message);
        reject(error);
      } else {
        console.log(response.array);
        resolve(response);
      }
    });
  });
}
